module.exports = __webpack_public_path__ + "static/general_labor-111abf828b416fd7ef496fa3523b60a0.jpg";